export default {"src":"/_next/static/media/location-pin.96c9087d.svg","height":13,"width":11};